import { render } from "./questionFour.vue?vue&type=template&id=3c1b8dda"
import script from "./questionFour.vue?vue&type=script&lang=ts"
export * from "./questionFour.vue?vue&type=script&lang=ts"

import "./questionFour.vue?vue&type=style&index=0&id=3c1b8dda&lang=css"
script.render = render

export default script